export const VerifyCoupon = `
    mutation ($code: String!, $email: String) {
        verifyCoupon (code: $code, email: $email) {
            code
            discount
        }
    }
`;
